import type { IdealLineReference, SavedCircuitConfigurationIdentity } from '@kangaroo/shared';
import {
  projectTrackPointsWithReferenceBounds,
  type MyChronGpsPoint,
  type TrackMapPoint,
} from './telemetrySession';

export function buildIdealLineMapPoints(
  reference: IdealLineReference | null | undefined,
  alignmentReferenceGps: MyChronGpsPoint[],
): TrackMapPoint[] {
  if (reference?.status !== 'available' || reference.points.length < 2) {
    return [];
  }

  const source: MyChronGpsPoint[] = reference.points.map((point) => ({
    ...point,
    alt: 0,
    fix: 3,
  }));
  return projectTrackPointsWithReferenceBounds(source, alignmentReferenceGps, 6000);
}

function configurationLabel(configuration: SavedCircuitConfigurationIdentity | null) {
  if (!configuration) {
    return 'exact circuit configuration unavailable';
  }

  const layout = configuration.layoutName ?? 'layout name unavailable';
  const direction = configuration.direction === 'clockwise' ? 'clockwise' : 'counterclockwise';
  return `${layout} · ${direction} · track ${configuration.trackId} · config ${configuration.contributionId}`;
}

export function idealLineReferenceStatusText(options: {
  reference: IdealLineReference | null | undefined;
  loading: boolean;
  error: unknown;
}) {
  if (options.loading) {
    return 'Loading fastest recorded lap…';
  }

  if (options.error) {
    return 'Fastest recorded lap could not be loaded.';
  }

  const { reference } = options;
  if (reference?.status !== 'available' || !reference.source || reference.points.length < 2) {
    return 'Fastest recorded lap unavailable for this driver and exact circuit configuration.';
  }

  const recorded =
    reference.source.recordedAtMs == null
      ? 'recorded date unavailable'
      : new Date(reference.source.recordedAtMs).toLocaleDateString();
  return `Fastest recorded lap: L${reference.source.lapNumber} · ${reference.source.durationSec.toFixed(3)} s · ${recorded} · ${configurationLabel(reference.configuration)} · session ${reference.source.sessionKey}`;
}
